(() => {
  const root = document.documentElement;
  const body = document.body;

  if (!body || body.dataset.motionLevel === 'none') {
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reduceMotion.matches) {
    return;
  }

  if (body.dataset.pointerEffect === 'true') {
    let frame = 0;

    window.addEventListener('pointermove', (event) => {
      if (frame) {
        return;
      }

      frame = window.requestAnimationFrame(() => {
        root.style.setProperty('--q-pointer-x', `${Math.round((event.clientX / window.innerWidth) * 100)}%`);
        root.style.setProperty('--q-pointer-y', `${Math.round((event.clientY / window.innerHeight) * 100)}%`);
        frame = 0;
      });
    }, { passive: true });
  }

  if (body.dataset.scrollReveal !== 'true') {
    return;
  }

  const revealTargets = () => document.querySelectorAll('.q-section:not(.q-cart), .q-product-card, .q-trust-card');

  if (!('IntersectionObserver' in window)) {
    revealTargets().forEach((target) => target.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  const observe = () => revealTargets().forEach((target) => observer.observe(target));

  observe();

  document.addEventListener('shopify:section:load', observe);
})();
